import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["data-testid"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResumeSkeleton',
    props: {
        testid: {},
        rows: { default: 2 }
    },
    setup(__props) {
        /**
         * Placeholder shown while a Résumé widget's own read is in flight. It exists so the widget never
         * renders its zero-valued default in the meantime: "0 € collecté" is a claim about the project,
         * and making it before the figures arrive is the same misreading a failed read would produce.
         */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col gap-2",
                "data-testid": __props.testid
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row) => {
                    return (_openBlock(), _createElementBlock("span", {
                        key: row,
                        class: _normalizeClass(["h-4 animate-pulse rounded bg-(--colors-border-base-soft)", row === __props.rows ? 'w-2/3' : 'w-full'])
                    }, null, 2 /* CLASS */));
                }), 128 /* KEYED_FRAGMENT */))
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
